import {getFaqTopList} from '@/api/help/home';
import {useQuery} from '@tanstack/react-query';

export const useGetFaqTopList = () => {
  return useQuery({
    queryKey: ['help', 'faq', 'topList'],
    queryFn: getFaqTopList,
    select: ({data}) =>
      data.faqList.map((faq) => ({
        category: faq.nodeName,
        categoryId: faq.nodeId,
        questionId: faq.kbId,
        title: faq.title,
      })),
  });
};
